import Promise from 'bluebird'
import dependsOnValErrors from '../lib/preparations/depends-on-validation-errors.js'

export default function (data) {
  return new Promise((resolve, reject) => {
    resolve( dependsOnValErrors(data) );
  });
};
